<section class="content">
  <div class="card" *ngIf="(paymentState | async).price !== null">
    <div class="card-body text-center">
      <h3 class="mt-3">You have chosen</h3>
      <h3 class="mt-1 mb-4">
        {{(paymentState | async).price.units}}
        <span *ngIf="(paymentState | async).price.units === 1">report</span>
        <span *ngIf="(paymentState | async).price.units > 1">reports</span>
        package
      </h3>
      <h5 class="sub-text"
          *ngIf="(paymentState | async).price.discount === undefined">
        Total price: {{(paymentState | async).price.total_price}}$
      </h5>
      <h5 class="sub-text"
          *ngIf="(paymentState | async).price.discount !== undefined">
        Total price: {{(paymentState | async).price.unit_price * (paymentState | async).price.units * (1 - ((paymentState | async).price.discount.discount / 100)) | number:'1.2-2'}}$
      </h5>
    </div>
    <div class="card-body">
      <div class="col-lg-6 payment mx-auto mb-4">
        <div class="card-tabs">
          <ul class="tabs" role="tablist">
            <li class="tabs-item"  [ngClass]="paymentType === 1 ? 'active' : ''">
              <a (click)="setPaymentType(1)">
                Card
              </a>
            </li>
            <li class="tabs-item" [ngClass]="paymentType === 2 ? 'active' : ''">
              <a (click)="setPaymentType(2)">
                PayPal
              </a>
            </li>
          </ul>
        </div>
        <div class="payment-content">
          <div *ngIf="paymentType === 1">
            <div class="text-red mb-4" *ngIf="invalidError">
              {{ invalidError.message }}
            </div>
            <div class="stripe-field mt-3">
              <stripe-card
                #stripeCard
                (catch) = "onStripeError($event)"
                [(invalid)] = "invalidError"
                (tokenChange) = "setStripeToken($event)"
                (sourceChange) = "setStripeSource($event)"
              ></stripe-card>
            </div>
            <div class="text-right my-3">
              <img src="./assets/images/powered_by_stripe.svg"/>
            </div>
            <div class="mt-3">
              <button class="btn btn-blue btn-lg btn-animated" type="button" [disabled]="(paymentState | async).paymentLoader.pay" (click)="stripeCard.createToken(); setPaymentLoader(true)">
              <span *ngIf="!(paymentState | async).paymentLoader.pay">
                Pay
                <span *ngIf="(paymentState | async).price.discount === undefined">
                  {{(paymentState | async).price.total_price}}$
                </span>
                <span *ngIf="(paymentState | async).price.discount !== undefined">
                  {{(paymentState | async).price.unit_price * (paymentState | async).price.units * (1 - ((paymentState | async).price.discount.discount / 100)) | number:'1.2-2'}}$
                </span>
              </span>
                <span *ngIf="(paymentState | async).paymentLoader.pay">Loading...</span>
              </button>
            </div>
          </div>
          <div class="my-5" *ngIf="paymentType === 2">
            <button class="btn btn-blue btn-lg btn-animated" type="button" (click)="onPayment()" [disabled]="loading">
            <span *ngIf="!loading">
              Pay
               <span *ngIf="(paymentState | async).price.discount === undefined">
                  {{(paymentState | async).price.total_price}}$
                </span>
                <span *ngIf="(paymentState | async).price.discount !== undefined">
                  {{(paymentState | async).price.unit_price * (paymentState | async).price.units * (1 - ((paymentState | async).price.discount.discount / 100)) | number:'1.2-2'}}$
                </span>
              with PayPal
            </span>
              <span *ngIf="loading">Loading...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


</section>
